export function formatCurrency(value, currency = "EUR", lang = "en", options = {}) {
  return new Intl.NumberFormat(lang === "de" ? "de-DE" : "en-GB", {
    style: "currency",
    currency: currency || "EUR",
    ...options,
  }).format(Number(value || 0));
}
